<template>
    <div class="appPage" ref="articlesRoll">
        <img src="../assets/banner.png" class="banner" />
        <img :src="ossLink + 'img1/titleArticles.png'" class="titleArticles" />
        <div class="articlesBox">
            <a v-for="(item, index) in listArticles" :key="'art_' + index" class="articlesList" :href="item.address"
                target="_blank">
                <img :src="item.photo" v-if="item.photo" />
                <div class="img" v-if="!item.photo"></div>
                <!-- <p class="h3">{{ item.title }}</p> -->
                <p>{{ item.subtitle }}</p>
            </a>
        </div>
        <Back :linkTo="'/'" />
    </div>
</template>

<script>
export default {
    name: 'HelloWorld',
    data () {
        return {
            ossLink: 'https://oss.eventnet.cn/H5/kwaiPlay/',
            listArticles: [],
        };
    },
    created () {
        const THAT = this;
        THAT.newsSet();
    },
    mounted () {
        const THAT = this;
        THAT.$refs.articlesRoll.scrollTop = 0;
    },
    methods: {
        jumpOut (url) {
            window.location.href = url;
        },
        newsSet () {
            const THAT = this;
            THAT.axios.get('https://oss.eventnet.cn/H5/kwaiPlay/img1/request1.json?v=' + new Date().getTime()).then(
                res => {
                    THAT.listArticles = res.news;
                }).catch(err => {
                    console.log(err);
                });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@font-face {
    font-family: font;
    src: url(../assets/font.ttf);
}

.appPage {
    background: url('../assets/bg1.jpg') no-repeat;
    background-size: 100%;
    background-position: center bottom;
    padding-top: 50px;
    padding-bottom: 150px;

    .banner {
        width: 691px;
        height: 387px;
        margin: 0 auto;
    }

    .titleArticles {
        width: 353px;
        height: 106px;
        margin: 50px auto;
    }
}

.kwaiBar {
    width: 684px !important;
    height: 368px !important;
    box-shadow: 0 0 25px rgba(233, 188, 125, 0.5);
    overflow: hidden;
    border-radius: 15px;
    margin: auto;

    .van-swipe-item {
        width: 684px !important;
        height: 368px !important;

        img {
            width: 100%;
            height: 368px;
        }
    }
}

.articlesBox {
    position: relative;
    z-index: 2;
    width: 684px;
    background-color: #fc591b;
    border-radius: 10px;
    margin: 0 auto 0;
    padding: 60px 17px 25px;
    font-family: font;

    .articlesList {
        position: relative;
        width: 100%;
        height: 130px;
        padding-left: 245px;
        margin-bottom: 30px;
        display: block;
        color: #fff;

        img {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 231px;
            height: 130px;
            border-radius: 8px;
        }

        .img {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 231px;
            height: 130px;
            border-radius: 8px;
            background: #2945d4;
        }

        .h3 {
            font-size: 28px;
            line-height: 40px;
            margin-bottom: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        p {
            font-size: 24px;
            line-height: 32px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        }
    }
}
</style>